'use client';
import { isArray, concat, isObject, objectEntries } from '@s7/utils';
import { mergeHeaders } from './core/utils/mergeHeaders/mergeHeaders.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Выполняет глубокое слияние ClientOptions.
 * - Отдельно обрабатывает объекты типа Headers.
 * - Выполняет слияние массивов конкатенацией.
 * */ const mergeOptions = (...sources)=>{
    let result = {};
    let headers = {};
    for (const source of sources){
        if (isArray(source)) {
            if (!isArray(result)) {
                result = [];
            }
            result = concat([
                result,
                source
            ]);
        } else if (isObject(source)) {
            // eslint-disable-next-line prefer-const --- Требуется мутировать value
            for (let [key, value] of objectEntries(source)){
                if (isObject(value) && key in result) {
                    value = mergeOptions(result[key], value);
                }
                result = _extends({}, result, {
                    [key]: value
                });
            }
            if (isObject(source.headers)) {
                headers = mergeHeaders(headers, source.headers);
                result.headers = headers;
            }
        }
    }
    return result;
};

export { mergeOptions };
//# sourceMappingURL=mergeOptions.js.map
